/* Fixed header & scrollable content */

.sc-fhsc {
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &__content {
    flex-grow: 1;
    overflow: auto;
  }

  &.--horizontal {
    flex-direction: row;
  }
}
